import { memo } from 'react';
import { DigitalRetailOverlayCTA } from 'reaxl-wallet';
import { EmailCTA } from 'reaxl-email';
import { Label } from 'reaxl';
import LendingOptionsCTA from './LendingOptionsCTA.js';
import OfferBreakdownCTA from './OfferBreakdownCTA.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
function FinancingCallToAction(_ref) {
  let {
    creditApp,
    digitalRetailProps,
    enableCreditApp,
    enableMyWallet,
    handleEmailCTAClick,
    handleLendingOptionsCTA,
    handleOfferBreakdownCTA,
    hideSendOfferCTA,
    isDRAccelerate,
    isOwnerFinancingSubmitted,
    listingId,
    onFinancingCTAClick,
    dealType,
    paymentErrorState,
    udsCTAs
  } = _ref;
  const isAmdCreditApp = enableCreditApp && isDRAccelerate;
  const isSacaCreditApp = enableCreditApp && !isDRAccelerate && !!onFinancingCTAClick;
  const {
    onCTAClick,
    ctaLabel,
    partner = '',
    url
  } = creditApp || {};
  const isCashTab = dealType === 'cash';
  let creditCTAProp = {
    glyph: 'offsite'
  };
  const hasCreditApp = () => !isCashTab && (handleLendingOptionsCTA && !isDRAccelerate || !enableCreditApp && !isDRAccelerate && !!creditApp || isAmdCreditApp || isSacaCreditApp && (!isOwnerFinancingSubmitted || isOwnerFinancingSubmitted && !hideSendOfferCTA));
  const dynamicGlyph = handleOfferBreakdownCTA ? null : 'chevron-right';
  const lendingOptionsCtaClassName = handleOfferBreakdownCTA ? 'text-nowrap margin-top-2' : 'margin-horizontal-2 text-nowrap margin-top-2';
  if (partner === 'psx') {
    creditCTAProp = {
      glyph: dynamicGlyph,
      target: '_self',
      rel: 'follow'
    };
  }
  const renderCreditAppCTA = /*#__PURE__*/jsx(LendingOptionsCTA, {
    enableMyWallet: enableMyWallet,
    callback: onCTAClick,
    label: ctaLabel,
    cmp: `${partner.toLowerCase()}-ca`,
    href: url,
    className: lendingOptionsCtaClassName,
    ...creditCTAProp
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!paymentErrorState && handleOfferBreakdownCTA && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(OfferBreakdownCTA, {
        enableMyWallet: enableMyWallet,
        callback: handleOfferBreakdownCTA
      }), hasCreditApp() && /*#__PURE__*/jsx("span", {
        className: "padding-horizontal-2 padding-horizontal-md-1 padding-horizontal-lg-2",
        children: "|"
      })]
    }), !isCashTab && /*#__PURE__*/jsxs(Fragment, {
      children: [handleLendingOptionsCTA && !isDRAccelerate && /*#__PURE__*/
      // Explore Financing
      jsx(LendingOptionsCTA, {
        enableMyWallet: enableMyWallet,
        callback: handleLendingOptionsCTA,
        className: lendingOptionsCtaClassName,
        glyph: dynamicGlyph
      }), !udsCTAs && !enableCreditApp && !isDRAccelerate && !!creditApp && renderCreditAppCTA, isAmdCreditApp && /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
        ...digitalRetailProps,
        buttonStyle: "primary",
        uiContext: "creditApp",
        glyph: dynamicGlyph
      }), isSacaCreditApp && /*#__PURE__*/jsxs(Fragment, {
        children: [!isOwnerFinancingSubmitted && /*#__PURE__*/
        // Apply for Financing
        jsx(LendingOptionsCTA, {
          enableMyWallet: enableMyWallet,
          callback: onFinancingCTAClick,
          label: "Apply for Financing",
          cmp: "std-ca",
          className: lendingOptionsCtaClassName,
          glyph: dynamicGlyph
        }), isOwnerFinancingSubmitted && !hideSendOfferCTA && /*#__PURE__*/jsx(EmailCTA, {
          listingId: listingId,
          type: "link",
          labelKey: "creditStatus",
          showIcon: false,
          onClick: handleEmailCTAClick
        }, "send-to-dealer-cta")]
      }), (isAmdCreditApp || isSacaCreditApp) && /*#__PURE__*/jsx("div", {
        className: "margin-top-2",
        children: /*#__PURE__*/jsxs(Label, {
          bsStyle: "info-inverse",
          className: "display-inline-flex align-items-baseline",
          children: [/*#__PURE__*/jsx("span", {
            className: "margin-right-1 glyphicon glyphicon-clock",
            "aria-hidden": "true"
          }), "Saves 45 min. at dealership"]
        })
      })]
    }), !!udsCTAs && /*#__PURE__*/jsx("div", {
      className: "margin-top-3 text-size-300",
      children: udsCTAs
    }), !isCashTab && !!udsCTAs && !enableCreditApp && !isDRAccelerate && !!creditApp && renderCreditAppCTA]
  });
}
var FinancingCallToAction$1 = /*#__PURE__*/memo(FinancingCallToAction);
export { FinancingCallToAction$1 as default };
